import { render, staticRenderFns } from "./premium.vue?vue&type=template&id=d10809b8&scoped=true"
var script = {}
import style0 from "./premium.vue?vue&type=style&index=0&id=d10809b8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d10809b8",
  null
  
)

export default component.exports